import type { Context } from "react";
import { createContext } from "react";

import type { PusherContextV2Value } from "@lib/pusher";

// createContext requires a value, but this default is never used: PusherProviderV2 always
// supplies the real methods. The methods stay undefined so a missing provider still throws
// a TypeError on call, which is the existing behavior.
const unavailableContext = {
  subscribeChannel: undefined,
  unsubscribeChannel: undefined,
} as unknown as PusherContextV2Value;

export const PusherContextV2: Context<PusherContextV2Value> = createContext(unavailableContext);
